import { 
  put, 
  fork,
  takeEvery, 
} from 'redux-saga/effects'; 
import { delay } from 'redux-saga'; 

import { GROWLER__SHOW } from './constants'; 
import { hideGrowler } from './actions';

export function* hide(action) {
  const timeoutTime = action.timeout !== undefined ? action.timeout : 5000;
  if (action.status === 'show' && timeoutTime > 0) {
    yield delay(timeoutTime);
    yield put(hideGrowler());
  }
}

export function* growlerSaga() {
  // Fork watcher so we can continue execution
  yield* [
    fork(takeEvery, GROWLER__SHOW, hide),
  ];
}

export default growlerSaga;



// WEBPACK FOOTER //
// ./src/containers/Notification/sagas.js